import React from 'react';
import { AddonsType } from 'utils/types';
import AddonAccordion from 'components/base/addon-accordion';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

type Props = {
  item: AddonsType;
  itemList: AddonsType[];
  onRefresh: () => Promise<void>;
};
const AddonCategory = ({ item, itemList, onRefresh }: Props) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: item.id
  });

  const style = {
    transition,
    transform: CSS.Transform.toString(transform)
  };
  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <AddonAccordion
        title={item.base_addon_category.name}
        addons={item.addons}
        id={item.id}
        mealId={item?.meal_parent_id}
        addonCategoryList={itemList}
        onRefresh={onRefresh}
      />
    </div>
  );
};

export default AddonCategory;
